import { useNavigate } from "react-router-dom";
import { ArrowRight, Check, Sparkle, LockOpen } from "@phosphor-icons/react";
import { PRICING } from "@/data/categories";

const PERKS = ["All 7 Life Seasons unlocked", "One payment — no subscription", "Your story, yours for life"];

export const LifetimeBanner = ({ onCta }) => {
  const navigate = useNavigate();
  return (
    <section
      data-testid="lifetime-banner"
      className="relative mb-8 overflow-hidden rounded-2xl ring-4 ring-[#F2B24C]/40 ring-offset-4 ring-offset-[#FDFBF7] bg-gradient-to-br from-[#E06D53] via-[#E8834F] to-[#F2B24C] p-6 text-white shadow-lg shadow-[#E06D53]/25 sm:p-8"
    >
      <Sparkle size={140} weight="fill" className="pointer-events-none absolute -right-6 -top-8 text-white/15" />
      <Sparkle size={56} weight="fill" className="pointer-events-none absolute bottom-6 right-40 hidden text-white/20 md:block" />
      <div className="relative flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-[#FFF4D6] ring-1 ring-white/40">
            <LockOpen size={14} weight="fill" /> Best value
          </span>
          <h2 data-testid="lifetime-banner-title" className="mt-3 font-serif text-3xl leading-tight sm:text-4xl">Lifetime Access, A$23.99 once</h2>
          <p data-testid="lifetime-banner-text" className="mt-2 max-w-xl text-base font-medium leading-relaxed text-white sm:text-lg">
            Unlock every Life Season and record unlimited memories for life.
          </p>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
            {PERKS.map((p) => (
              <li key={p} className="flex items-center gap-1.5 text-sm font-medium">
                <Check size={16} weight="bold" className="text-[#FFF4D6]" /> {p}
              </li>
            ))}
          </ul>
        </div>
        <div className="shrink-0 text-left md:text-center">
          <p data-testid="lifetime-banner-price" className="font-serif text-5xl leading-none">
            {PRICING.currency}{PRICING.lifetime.price.toFixed(2)}
          </p>
          <p className="mt-1 text-xs text-white/85">AUD · one-time · No GST applies</p>
          <button
            data-testid="lifetime-banner-btn"
            onClick={() => (onCta ? onCta() : navigate("/upgrade"))}
            className="mt-4 inline-flex min-h-[48px] items-center gap-2 rounded-full bg-white px-7 text-base font-semibold text-[#C2502F] shadow-md transition-transform hover:-translate-y-0.5 hover:shadow-lg"
          >
            Unlock my whole story <ArrowRight size={18} weight="bold" />
          </button>
        </div>
      </div>
    </section>
  );
};
